import autocomplete, {
  AutocompleteItem,
  AutocompleteSettings,
} from 'autocompleter';
import { Place } from '~/blocks/widget/frontend/types';
import { getComponentOption, getInput } from '~/js/utils/selectors';
import clickbusClient from '~/blocks/widget/frontend/api';

type PlaceSuggestion = Place & AutocompleteItem;

const config: Partial<AutocompleteSettings<PlaceSuggestion>> = {
  emptyMsg: 'Nenhum resultado encontrado.',
  className: 'widget-autocomplete-list',
  preventSubmit: true,

  /* Autocompleter waits for a div, but we will provide a
   * button for accessibility reasons. */

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  render: ({ name, slug }) => {
    const suggestion = document.createElement('button');
    suggestion.setAttribute('data-slug', slug);
    suggestion.innerHTML = name;

    return suggestion;
  },
};

function createAutocomplete(input: HTMLInputElement, form: HTMLFormElement) {
  const clientId = getComponentOption(form, 'client-id');
  const inputId = input.getAttribute('name');

  return autocomplete<PlaceSuggestion>({
    ...config,
    input,
    fetch: async (text, update) => {
      const resource = `places?clientId=${clientId}&limit=7&name=${text}`;
      const places = await clickbusClient<Place[]>('GET', resource);

      update(places);
    },
    onSelect: ({ name, slug }) => {
      input.value = name;
      input.setAttribute(`data-${inputId}`, slug);
      if (inputId === 'origin') getInput('[name="destination"]', form).focus();
    },
  });
}

export default createAutocomplete;
